export default __webpack_public_path__ + "d77245eecf36d9cc5a07206674b4d9c0.png";